import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-loading-box',
  templateUrl: './loading-box.component.html',
  styleUrls: ['./loading-box.component.css']
})
export class LoadingBoxComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
